import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "fullscreen-modal__footer" }
const _hoisted_2 = {
  key: 0,
  class: "fullscreen-modal__footer-top"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-arrow-right icon-rotate-180",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "d-flex align-items-center me-md-3 fullscreen-modal__footer-bottom--price"
}
const _hoisted_5 = { class: "ms-2" }
const _hoisted_6 = {
  key: 1,
  class: "fullscreen-modal__footer-bottom--currency"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-check",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_8 = {
  key: 3,
  class: "fullscreen-modal__validation-error fullscreen-modal__footer-bottom--error"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", {
  class: "icon icon-check",
  "aria-hidden": "true"
}, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Select = _resolveComponent("Select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "btn-no-styling btn-link-grey",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
          }, [
            _hoisted_3,
            _createTextVNode(" " + _toDisplayString(_ctx.translate('general.go-back')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", {
      class: _normalizeClass(["fullscreen-modal__footer-bottom", _ctx.stepViews[_ctx.step] !== 'calendar' && _ctx.stepViews[_ctx.step] !== 'services' ? 'fullscreen-modal__footer-bottom-grid' : ''])
    }, [
      (_ctx.stepViews[_ctx.step] !== 'calendar' && _ctx.stepViews[_ctx.step] !== 'services')
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createTextVNode(_toDisplayString(_ctx.translate('shop.configuration.total')) + " ", 1),
            _createElementVNode("strong", _hoisted_5, _toDisplayString(_ctx.convertInCurrency(_ctx.ticketConfigurations.finalPrice, _ctx.selectedCurrency)), 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.stepViews[_ctx.step] !== 'calendar')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_Select, {
              label: _ctx.translate('Shop.configuration.select-currency'),
              id: "currency",
              name: "currency",
              onChangeValue: _ctx.onChangeCurrency,
              selectedOption: _ctx.selectedCurrency,
              options: _ctx.currencyOptions,
              className: "fullscreen-modal__currency-select"
            }, null, 8, ["label", "onChangeValue", "selectedOption", "options"])
          ]))
        : _createCommentVNode("", true),
      (!_ctx.isMobile)
        ? (_openBlock(), _createElementBlock("button", {
            key: 2,
            class: _normalizeClass(["btn btn-tertiary fullscreen-modal__submit", !_ctx.stepValidation.isValid() ? 'btn-light-disabled' : '']),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onChangeStep(_ctx.step+1)))
          }, [
            _hoisted_7,
            _createTextVNode(" " + _toDisplayString(_ctx.translate('shop.configuration.save & next')), 1)
          ], 2))
        : _createCommentVNode("", true),
      (_ctx.showErrorMessage)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.errorMessage), 1))
        : _createCommentVNode("", true)
    ], 2),
    (_ctx.isMobile)
      ? (_openBlock(), _createElementBlock("button", {
          key: 1,
          class: _normalizeClass(["btn btn-tertiary fullscreen-modal__submit", !_ctx.stepValidation.isValid() ? 'btn-light-disabled' : '']),
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onChangeStep(_ctx.step+1)))
        }, [
          _hoisted_9,
          _createTextVNode(" " + _toDisplayString(_ctx.translate('shop.configuration.save & next')), 1)
        ], 2))
      : _createCommentVNode("", true)
  ]))
}